(() => {
  if (window.KenzuBrandStoryBooted) return;

  window.KenzuBrandStoryBooted = true;

  const SELECTOR = "[data-kenzu-brand-story]";
  const initializedSections = new WeakSet();
  const observedSections = new WeakSet();

  document.documentElement.classList.add(
    "kbs-js-enabled"
  );

  let intersectionObserver = null;

  /**
   * Comprueba si el usuario prefiere reducir movimiento.
   */
  const prefersReducedMotion = () => {
    return window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
  };

  /**
   * Marca una sección como visible.
   */
  const revealSection = (section) => {
    if (!section) return;

    section.classList.add("is-visible");
  };

  /**
   * Crea un IntersectionObserver compartido.
   */
  const getIntersectionObserver = () => {
    if (intersectionObserver) {
      return intersectionObserver;
    }

    if (!("IntersectionObserver" in window)) {
      return null;
    }

    intersectionObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          revealSection(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -8% 0px",
        threshold: 0.14
      }
    );

    return intersectionObserver;
  };

  /**
   * Inicializa una sección individual.
   */
  const initializeSection = (section) => {
    if (!section) return;
    if (initializedSections.has(section)) return;

    initializedSections.add(section);

    const animation =
      section.dataset.animation || "none";

    if (
      animation === "none" ||
      prefersReducedMotion()
    ) {
      revealSection(section);
      return;
    }

    const observer = getIntersectionObserver();

    if (!observer) {
      revealSection(section);
      return;
    }

    observer.observe(section);
    observedSections.add(section);
  };

  /**
   * Busca secciones dentro de un nodo.
   */
  const initializeSections = (root = document) => {
    const sections = [];

    if (
      root instanceof Element &&
      root.matches(SELECTOR)
    ) {
      sections.push(root);
    }

    if (
      root instanceof Document ||
      root instanceof DocumentFragment ||
      root instanceof Element
    ) {
      sections.push(
        ...root.querySelectorAll(SELECTOR)
      );
    }

    sections.forEach(initializeSection);
  };

  /**
   * Deja de observar una sección eliminada desde el editor.
   */
  const unloadSections = (root) => {
    if (!root || !intersectionObserver) return;

    const sections = [];

    if (
      root instanceof Element &&
      root.matches(SELECTOR)
    ) {
      sections.push(root);
    }

    if (root instanceof Element) {
      sections.push(
        ...root.querySelectorAll(SELECTOR)
      );
    }

    sections.forEach((section) => {
      if (observedSections.has(section)) {
        intersectionObserver.unobserve(section);
      }
    });
  };

  /**
   * Inicialización principal.
   */
  const boot = () => {
    initializeSections(document);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  /**
   * Compatibilidad con el editor de Shopify.
   */
  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initializeSections(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      unloadSections(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:select",
    (event) => {
      const section =
        event.target.matches?.(SELECTOR)
          ? event.target
          : event.target.querySelector?.(SELECTOR);

      if (section) {
        revealSection(section);
      }
    }
  );
})();